var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygonIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_359_302)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_359_302",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 0H0V28H28V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_359_302)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_359_302",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 0H0V28H28V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_359_302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2019 9.21178C20.932 9.06777 20.6307 8.99244 20.3248 8.99244C20.0189 8.99244 19.7176 9.06777 19.4477 9.21178L15.3527 11.624L12.5751 13.1528L8.55428 15.5719C8.28435 15.716 7.98312 15.7913 7.67718 15.7913C7.37124 15.7913 7.07 15.716 6.80008 15.5719L3.65568 13.6708C3.38772 13.513 3.16572 13.2878 3.01174 13.0177C2.85775 12.7475 2.77712 12.4417 2.77788 12.1308V8.47958C2.7792 8.16902 2.86069 7.86407 3.01448 7.59427C3.16827 7.32447 3.38913 7.09895 3.65568 6.93958L6.79868 5.11678C7.0686 4.97277 7.36984 4.89744 7.67578 4.89744C7.98172 4.89744 8.28295 4.97277 8.55288 5.11678L11.6973 7.01798C11.9652 7.17577 12.1872 7.40095 12.3412 7.67111C12.4952 7.94126 12.5758 8.24701 12.5751 8.55798V10.966L15.3527 9.35738V6.87238C15.3514 6.56182 15.2698 6.25687 15.1161 5.98708C14.9622 5.71727 14.7414 5.49175 14.4749 5.33238L8.62708 1.90098C8.35715 1.75697 8.05592 1.68164 7.74998 1.68164C7.44404 1.68164 7.1428 1.75697 6.87288 1.90098L0.878077 5.40938C0.609293 5.54638 0.384454 5.75621 0.229237 6.01491C0.0740194 6.27361 -0.00532057 6.57073 0.000276994 6.87238V13.7436C0.0015931 14.0542 0.0830931 14.3591 0.236881 14.6289C0.39067 14.8987 0.611534 15.1242 0.878077 15.2835L6.80008 18.7191C7.07 18.8632 7.37124 18.9385 7.67718 18.9385C7.98312 18.9385 8.28435 18.8632 8.55428 18.7191L12.5751 16.3727L15.3527 14.7641L19.3735 12.4248C19.6434 12.2808 19.9447 12.2054 20.2506 12.2054C20.5565 12.2054 20.8578 12.2808 21.1277 12.4248L24.2707 14.2517C24.5386 14.4096 24.7607 14.6348 24.9147 14.905C25.0685 15.175 25.1492 15.4808 25.1485 15.7917V19.4527C25.1472 19.7634 25.0656 20.0683 24.9119 20.3381C24.758 20.6079 24.5372 20.8334 24.2707 20.9927L21.2019 22.8127C20.932 22.9568 20.6307 23.0321 20.3248 23.0321C20.0189 23.0321 19.7176 22.9568 19.4477 22.8127L16.3047 20.9857C16.0367 20.8279 15.8147 20.6028 15.6607 20.3326C15.5067 20.0624 15.4262 19.7568 15.4269 19.4457V17.1063L12.6479 18.7149V21.1327C12.6492 21.4434 12.7307 21.7483 12.8845 22.0181C13.0383 22.2879 13.2591 22.5134 13.5257 22.6727L19.4477 26.1083C19.7176 26.2524 20.0189 26.3277 20.3248 26.3277C20.6307 26.3277 20.932 26.2524 21.2019 26.1083L27.1239 22.6727C27.3916 22.5148 27.6133 22.2895 27.767 22.0193C27.9208 21.7493 28.0011 21.4437 28.0003 21.1327V14.1831C27.999 13.8726 27.9174 13.5677 27.7637 13.2979C27.6098 13.0281 27.389 12.8026 27.1225 12.6432L21.2019 9.21178Z",
    fill: "#8247E5"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_359_302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonIcon);
export default __webpack_public_path__ + "static/media/Polygon-icon.b802e3230f44e97874f8d9440d40e140.svg";
export { ForwardRef as ReactComponent };